import React, { useCallback, useState } from 'react';
import { Content, Button, Flex, Text, Label, Pane, Radio } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import { Config } from '@leverege/plugin';
import S from './PairingFlow.css';
import Scan from './Scan';
import DeviceSearch from './DeviceSearch';
import DeviceInput from './DeviceInput';
import C from '../salesFlow/Constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT_OPTIONS = [{
  label: 'Vehicle Only Sale',
  value: C.SALE_TYPES.VEHICLE_ONLY
}, {
  label: 'Vehicle Wholesale',
  value: C.SALE_TYPES.VEHICLE_WHOLESALE
}, {
  label: 'Dealer Trade',
  value: C.SALE_TYPES.DEALER_TRADE
}, {
  label: 'Locator Issue',
  value: 'locator-issue'
}, {
  label: 'Other',
  value: 'other'
}];
export default function UnpairForm(props) {
  const {
    areaClassName,
    footerClassName,
    onClose,
    onChange: pOnChange,
    onUnpair,
    asset,
    tracker,
    trackerId,
    trackerInstallLocation,
    unpairReason,
    loading,
    titleVariant,
    titleIcon
  } = props;
  const [activeScreen, setActiveScreen] = useState('main');
  const onChangeNext = useCallback(evt => {
    if (asset?.data?.pendingSaleId) {
      pOnChange({
        data: 'tabId',
        value: 'unpair-and-sell'
      });
    } else {
      pOnChange({
        data: 'tabId',
        value: unpairReason === 'locator-issue' || unpairReason === 'other' ? 'unpair-and-other' : 'unpair-and-sell'
      });
    }
  }, [pOnChange, unpairReason]);
  const onChangeRadio = useCallback(evt => {
    pOnChange({
      data: 'unpairReason',
      value: evt.data
    });
  }, [pOnChange]);
  const onClick = useCallback(({
    data
  }) => {
    setActiveScreen(data.screen);
  }, [setActiveScreen]);
  const onChange = useCallback(evt => {
    setActiveScreen('main');
    pOnChange(evt);
  }, [pOnChange]);
  const onFocusTracker = useCallback(({
    data
  }) => {
    setActiveScreen(data.screen);
  });
  let header = null;
  let content = null;
  let footer = null;
  let body = null;
  const showInstallLocation = !!tracker;
  const enablingUnpairOptions = Config.get('UnpairForm', 'showUnpairOptions', true);
  const showUnpairOptions = !asset?.data?.pendingSaleId && enablingUnpairOptions;

  // customUnpairOptions is an array of strings that match the value of 1 or more DEFAULT_OPTIONS 
  const customUnpairOptions = Config.get('UnpairForm', 'customOptions', []);
  const DISPLAYED_OPTIONS = customUnpairOptions.length ? DEFAULT_OPTIONS.filter(item => customUnpairOptions.includes(item.value)) : DEFAULT_OPTIONS;
  switch (activeScreen) {
    case 'scan':
      content = /*#__PURE__*/_jsx(Scan, {
        ...props,
        eventData: "trackerId",
        onClick: onClick,
        onChange: onChange
      });
      break;
    case 'search':
      body = /*#__PURE__*/_jsx(DeviceSearch, {
        ...props,
        pairing: false,
        eventData: "trackerId",
        value: trackerId,
        onChange: onChange,
        onClick: onClick,
        additionalFilters: [{
          type: 'exists',
          field: 'data/vehicle/id'
        }]
      });
      break;
    default:
      header = /*#__PURE__*/_jsx(TitleBar, {
        variant: titleVariant,
        title: "Unpair Locator from Vehicle",
        "data-cy": Config.get('cypress', ['text', 'locator.unpairFromVehicle'], 'text.locator.unpairFromVehicle'),
        icon: titleIcon
      });
      content = /*#__PURE__*/_jsxs(Flex, {
        variant: "colL",
        children: [/*#__PURE__*/_jsx(Text, {
          className: S.body,
          children: "Choose which locator you'd like to unpair."
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "colS",
          children: [/*#__PURE__*/_jsx(Label, {
            variant: "inputTitle",
            children: "Locator ID"
          }), /*#__PURE__*/_jsx(DeviceInput, {
            "data-test-postfix": "Locator",
            hint: "Search Locator",
            eventData: "trackerId",
            value: trackerId,
            onChange: onChange,
            onFocus: onFocusTracker,
            onClick: onClick
          })]
        }), showInstallLocation && /*#__PURE__*/_jsx(Pane, {
          className: S.container,
          children: /*#__PURE__*/_jsxs(Flex, {
            variant: "row",
            justify: "space-between",
            children: [/*#__PURE__*/_jsx(Text, {
              className: S.name,
              children: "Install Location"
            }), /*#__PURE__*/_jsx(Text, {
              className: S.value,
              children: trackerInstallLocation
            })]
          })
        }), showUnpairOptions && /*#__PURE__*/_jsxs(Flex, {
          variant: "colM",
          children: [/*#__PURE__*/_jsx(Label, {
            variant: "inputTitle",
            children: "Reason for Unpairing"
          }), DISPLAYED_OPTIONS.map(opt => /*#__PURE__*/_jsx(Radio, {
            containerClassName: opt.value === unpairReason ? S.activeUnpairOption : S.unpairOption,
            variant: "pairing",
            eventData: opt.value,
            label: opt.label,
            on: opt.value,
            value: unpairReason,
            onChange: onChangeRadio
          }, opt.value))]
        })]
      });
      footer = /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          variant: "secondary",
          children: "Cancel"
        }), /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          disabled: !trackerId || showUnpairOptions && !unpairReason || loading,
          onClick: !enablingUnpairOptions ? onUnpair : onChangeNext,
          children: !enablingUnpairOptions ? 'Unpair' : 'Next'
        })]
      });
  }
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [header && /*#__PURE__*/_jsxs(Content.Header, {
      children: [header, /*#__PURE__*/_jsx(Button, {
        variant: "closeDialog",
        className: S.close,
        onClick: onClose
      })]
    }), content && /*#__PURE__*/_jsx(Content.Area, {
      className: areaClassName,
      children: content
    }), footer && /*#__PURE__*/_jsx(Content.Footer, {
      className: footerClassName,
      layout: "flex:rowMEnd",
      children: footer
    }), body]
  });
}